module.exports = __webpack_public_path__ + "static/media/clock still 02.0f5d0734.webp";